<button (click)="print()">
  <ng-content>
  </ng-content>
  <fa-icon
    *ngIf="iconName"
    [icon]="iconName" [class.onlyIcon]="onlyIcon">
  </fa-icon>
</button>
